var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.423248,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2552",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.423248,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.423248 4.26667H22.4232V0H0.423248V4.26667Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.423248 16H22.4232V11.7333H0.423248V16Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.423248 11.7333H22.4232V4.26667H0.423248V11.7333Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18515 7.46667H7.23277V8H6.18515V7.46667Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5991 7.26667H6.77123C6.96605 7.26667 7.11934 7.43302 7.10345 7.62719L6.98602 9.06202C6.95189 9.47898 6.60353 9.8 6.18516 9.8C5.7668 9.8 5.41844 9.47898 5.38431 9.06201L5.26688 7.62719C5.25099 7.43302 5.40428 7.26667 5.5991 7.26667Z",
    stroke: "#A41517",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13754 8H7.23278V8.53333H6.70897L6.18516 9.6L5.66135 8.53333H5.13754V8Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5661,
    y: 6.4,
    width: 1.04762,
    height: 3.73333,
    rx: 0.52381,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.75659,
    y: 6.4,
    width: 1.04762,
    height: 3.73333,
    rx: 0.523809,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13754 6.18667C5.13754 5.71538 5.51959 5.33333 5.99088 5.33333H6.37945C6.85073 5.33333 7.23278 5.71538 7.23278 6.18667V6.18667C7.23278 6.30449 7.13727 6.4 7.01945 6.4H5.35088C5.23306 6.4 5.13754 6.30449 5.13754 6.18667V6.18667Z",
    fill: "#A41517"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.e0111b57965a63e5d1d27fdbbb2d5439.svg";
export { ForwardRef as ReactComponent };